/* AFS7 - abonnementskeuzes in de buy box: bezorgfrequentie en hoeveelheid,
   plus een eerlijke actief-staat op de twee plannen.

   Waarom dit er is
   ----------------
   1. Elk abonnementsproduct heeft TWEE plannen: maandelijks en per 3 maanden.
      Seal rendert daar zelf een <select name="subs_interval"> voor, maar het hele
      Seal-blok staat op display:none omdat het thema zijn eigen plankeuze tekent.
      Gevolg: niemand kon kiezen, alles werd stilzwijgend maandelijks, en de buy
      box beloofde ondertussen "Delivery frequency chosen in your cart" - terwijl
      de cart helemaal geen frequentiekeuze heeft. Gemeten 2026-09-20.
   2. Diezelfde verwijdering van de radio's breekt de actief-staat: het thema
      kleurt de gekozen box met :has(input:checked), en die input bestaat niet
      meer. De One-time box bleef daardoor altijd beige met zwarte rand, ook als
      het abonnement gekozen was. We zetten daarom zelf een klasse op .afs2-plans.

   Twee eerdere valkuilen, voor wie dit later leest
   ------------------------------------------------
   - Seal voegt zijn select pas toe nadat zijn script geladen is. Draaide dit
     bestand daarvoor, dan waren er nul opties en zette de guard de boel op slot,
     zodat de frequentierij de hele sessie ontbrak. De guard geldt nu alleen voor
     wat al gelukt is.
   - De teller heette eerst .afs7-step, net als de kaart in "hoe het werkt". Die
     kaart heeft flex-direction:column, dus de knoppen stapelden verticaal. De
     teller heet nu .afs7-qtystep. */
(function () {
  'use strict';
  if (window.__afs7SubQty) return;
  window.__afs7SubQty = true;

  var CFG = window.__afs7SubText || {};

  function isSub(scope) {
    var f = scope.querySelectorAll('[name^="subs_type"]');
    for (var i = 0; i < f.length; i++) {
      if (f[i].type === 'radio') { if (f[i].checked && f[i].value !== 'one_time') return true; }
      else if (f[i].value && f[i].value !== 'one_time') return true;
    }
    var own = scope.querySelector('input[name="selling_plan"]:checked');
    if (own && own.value) return true;
    return !!scope.querySelector('.afs2-plan.is-sub-selected');
  }

  function row(label) {
    var r = document.createElement('div');
    r.className = 'afs7-subrow';
    var l = document.createElement('span');
    l.className = 'afs7-subrow__l';
    l.textContent = label;
    r.appendChild(l);
    return r;
  }

  function addFreq(box, form, root, subPlan) {
    if (box.__freq) return true;
    var sel = form.querySelector('select[name="subs_interval"]');
    if (!sel) return false;
    var opts = [].slice.call(sel.options).filter(function (o) { return o.value; });
    if (opts.length < 2) return opts.length === 1;
    box.__freq = true;

    var fr = row(CFG.freqLabel || 'Delivered');
    var pills = document.createElement('span');
    pills.className = 'afs7-pills';
    opts.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'afs7-pill';
      b.setAttribute('data-plan', o.value);
      b.textContent = o.textContent.trim();
      b.setAttribute('aria-pressed', String(o.value === sel.value));
      pills.appendChild(b);
    });
    fr.appendChild(pills);
    box.insertBefore(fr, box.firstChild);

    pills.addEventListener('click', function (e) {
      var b = e.target.closest('.afs7-pill');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var id = b.getAttribute('data-plan');
      sel.value = id;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      root.setAttribute('data-afs2-plan-want', id);
      [].slice.call(pills.children).forEach(function (p) {
        p.setAttribute('aria-pressed', String(p === b));
      });
      root.dispatchEvent(new CustomEvent('afs2:plan-change', { bubbles: true }));
    });
    root.setAttribute('data-afs2-plan-want', sel.value || '');

    if (CFG.subNote) {
      var note = subPlan.querySelector('.afs2-plan__sub');
      if (note) note.textContent = CFG.subNote;
    }
    return true;
  }

  function wire(plans) {
    var form = plans.closest('form[action*="/cart/add"]');
    if (!form) return;
    var root = plans.closest('[data-afs2-product]') || form;

    var subPlan = null;
    var labels = plans.querySelectorAll('.afs2-plan');
    for (var i = 0; i < labels.length; i++) {
      if (/subscribe/i.test(labels[i].textContent)) subPlan = labels[i];
    }
    if (!subPlan) return;

    if (plans.__afs7Box) { addFreq(plans.__afs7Box, form, root, subPlan); return; }

    var box = document.createElement('div');
    box.className = 'afs7-subopts';
    plans.__afs7Box = box;

    addFreq(box, form, root, subPlan);

    var qty = form.querySelector('input[name="quantity"]');
    if (!qty) {
      qty = document.createElement('input');
      qty.type = 'hidden';
      qty.name = 'quantity';
      qty.value = '1';
      form.appendChild(qty);
    }
    var qr = row(CFG.qtyLabel || 'Bottles per delivery');
    var ctl = document.createElement('span');
    ctl.className = 'afs7-qtystep';
    ctl.innerHTML = '<button type="button" data-afs7-q="-1" aria-label="One less">&minus;</button>' +
                    '<b data-afs7-qv>1</b>' +
                    '<button type="button" data-afs7-q="1" aria-label="One more">+</button>';
    qr.appendChild(ctl);
    box.appendChild(qr);
    subPlan.appendChild(box);

    var val = ctl.querySelector('[data-afs7-qv]');
    function set(n) {
      n = Math.max(1, Math.min(12, n));
      qty.value = String(n);
      val.textContent = String(n);
    }
    ctl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-afs7-q]');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      set(parseInt(qty.value || '1', 10) + parseInt(b.getAttribute('data-afs7-q'), 10));
    });

    function sync() {
      var on = isSub(form);
      box.classList.toggle('is-on', on);
      plans.classList.toggle('afs7-mode-sub', on);
      plans.classList.toggle('afs7-mode-one', !on);
      if (!on) set(1);
    }
    var later = function () { setTimeout(sync, 0); setTimeout(sync, 250); };
    form.addEventListener('change', later, true);
    form.addEventListener('click', later, true);
    later();
  }

  function init() {
    var all = document.querySelectorAll('.afs2-plans');
    for (var i = 0; i < all.length; i++) wire(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }
  document.addEventListener('shopify:section:load', init);

  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    init();
    var box = document.querySelector('.afs7-subopts');
    if ((box && box.__freq) || tries > 40) clearInterval(poll);
  }, 500);
})();